import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import { Mortgage } from "../mortgage/Mortgage";
import { CostPer } from "../costPer/CostPer";
import { ChannelMix } from "../channelMix/ChannelMix";

export const Calculators = () => {
	const calculators = useSelector(state => state.calculators.schema);
	const elements = {mortgage: <Mortgage />, costPer: <CostPer />, channelMix: <ChannelMix />};

	return (
		<Box id="calc" component="main" sx={{pb: 3, bgcolor: "common.white"}}>
			<Routes>
				{calculators.map(({path, element}, key) =>
					<Route key={`route_${key}`} {...{path}} element={elements[element]} />
				)}
			</Routes>
		</Box>
	);
};
